import { getSeamlessPromotionInfo, checkSeamlessMemberPromotionStatus, getSeamlessPromotions } from '@pm/super-library-2/modules/seamless';

import { PROVIDER_CATEOGRY_PREFIX } from '@constants';
import { seamlessAction } from '@redux/action';

export async function seamless_verifySpecialPromoCode(login, promoCode, amount) {
    if (promoCode) {
        try {
            let returnAmount = '';
            const res = await window.SPL_Member.verifySpecialPromotionsCode(login, promoCode, amount);
            const _specialPromo = res?.specialPromo;
            if (res?.isValidPromo && !_specialPromo?.exceedMaxBonus) {
                returnAmount = res.isValidSpecialPromoAmount ? amount : '';
            }

            return {
                isValidSpecialPromoCode: res?.isValidPromo,
                amount: returnAmount,
                minimumAmount: res?.minimumAmount,
                specialPromoInfo: _specialPromo,
            };
        } catch (err) {
            console.error(err);
        }
    } else {
        return {
            isValidSpecialPromoCode: true,
            amount: amount,
            minimumAmount: 0,
            specialPromoInfo: null,
        };
    }
}

// Helper function to map provider category
const _mapProviderCategoryToProviderCode = (providerCategory) => {
    const mapList = PROVIDER_CATEOGRY_PREFIX;
    return mapList?.[providerCategory] || null;
};

// Helper function to process category providers map
const _massageCategoryProvidersMap = (categoryProvidersMap = {}, subCategoryMenus = {}, t) => {
    return Object.entries(categoryProvidersMap).reduce((processedMap, [providerCategory, providerStrings]) => {
        const providerCode = _mapProviderCategoryToProviderCode(providerCategory);
        const splitProviderStrings = providerStrings.split(',');

        let tempProviderList = [];
        splitProviderStrings.forEach((provider) => {
            if (subCategoryMenus?.[providerCode]?.length > 0) {
                subCategoryMenus?.[providerCode].forEach((submenuObj) => {
                    if (submenuObj?.provider === provider) {
                        const providerName = t?.(submenuObj?.content);
                        tempProviderList.push(providerName);
                    }
                });
            }
        });

        if (providerCode) {
            processedMap[providerCode] = tempProviderList.join(', ');
        }
        return processedMap;
    }, {});
};

export async function seamless_getSeamlessPromotionInfo(promoId, subCategoryMenus, t) {
    if (!promoId) {
        return null;
    }

    try {
        const res = await getSeamlessPromotionInfo(promoId);
        const data = res?.data;

        if (!data) {
            throw new Error('No promotion data found');
        }

        const { targetMultiplier, rate, minBonus, maxBonus, categoryProvidersMap, validity } = data;
        const processedPromoInfo = {
            targetMultiplier,
            maxBonus,
            rate: rate * 100,
            minDeposit: minBonus / rate,
            maxDeposit: maxBonus / rate,
            categoryProvidersMap: _massageCategoryProvidersMap(categoryProvidersMap, subCategoryMenus, t),
            validity,
        };

        return processedPromoInfo;
    } catch (err) {
        console.error('Error fetching promotion info:', err);
        return null; // Return null on error, you can customize this behavior
    }
}

export const seamless_getWallet = async ({ seamless, isLogin, dispatch, callback }) => {
    const { isSeamless, providerWallets } = seamless || {};
    if (!isSeamless || (!isLogin && window.isAffiliate)) return;

    let param = {
        isRecalculate: true,
    };

    const getMassageSeamlessMemberRestrictionWalletLock = (providerWallets, seamlessMemberRestrictionWalletLock) => {
        const providerWalletsArrayMap = new Map();
        (providerWallets || []).forEach((item) => {
            const provider = item?.provider;
            if (provider) {
                providerWalletsArrayMap.set(provider, item?.name);
            }
        });

        // Merge the "name" property from providerWalletsArray into tempSeamlessMemberRestrictionWalletLock
        const updatedSeamlessMemberRestrictionWalletLock = (seamlessMemberRestrictionWalletLock || []).forEach((item) => {
            const provider = item?.provider;
            if (provider && providerWalletsArrayMap.has(provider)) {
                item.name = providerWalletsArrayMap.get(provider);
            }
        });

        return updatedSeamlessMemberRestrictionWalletLock;
    };

    try {
        const seamlessMemberWallet = await window.SPL_Member.getTotalBalanceDetails(param);
        const { seamlessMemberRestrictionWalletLock, seamlessWalletBalance, mainWalletBalance } = seamlessMemberWallet || {};

        const processedSeamlessMemberWallet = {
            ...seamlessMemberWallet,
            seamlessMainWalletBalance: seamlessWalletBalance >= 0 && mainWalletBalance >= 0 ? mainWalletBalance + seamlessWalletBalance : 0,
            seamlessMemberRestrictionWalletLock: getMassageSeamlessMemberRestrictionWalletLock(providerWallets, seamlessMemberRestrictionWalletLock),
        };

        dispatch(seamlessAction.getSeamlessMemberWallet(processedSeamlessMemberWallet));
        callback && callback();
    } catch (err) {
        console.error(err);
    }
};

export const seamless_fullSeamlessMode = (accountMenu) => {
    const updatedAccountMenu = Array.isArray(accountMenu) && accountMenu?.length > 0 && accountMenu.filter((menu) => (menu.key || menu.id) !== 'transfer');

    return updatedAccountMenu;
};

export const seamless_checkMemberPromotionStatus = async ({ dispatch, seamless }) => {
    const { isSeamless, isSeamlessPromotionExist } = seamless || {};
    let promoStatus = [];

    if (isSeamless) {
        const res = await checkSeamlessMemberPromotionStatus('P,A', isSeamlessPromotionExist);
        promoStatus = res.data;

        if (promoStatus?.length <= 0) {
            dispatch(seamlessAction.isSeamlessPromotionExist(false));
        } else {
            dispatch(seamlessAction.seamlessPromotionData(promoStatus));
            dispatch(seamlessAction.isSeamlessPromotionExist(true));
        }
    }

    return { memberPromotionStatus: promoStatus };
};

export const seamless_massageSelectedSeamlessPromo = (seamless) => {
    const { specialPromoObj, promoObj } = seamless || {};

    let selectedSeamlessPromoObj = null;
    let selectedSeamlessPromoId = null;
    let selectedSeamlessPromoCode = null;

    const selectedPromoId = promoObj?.id || null;

    // const _filterSelectedPromo = (promoList) => {
    //     return promoList?.find((promo) => promo.id === parseInt(selectedSeamlessPromoObj?.id));
    // };

    if (specialPromoObj) {
        selectedSeamlessPromoObj = specialPromoObj;
        if (selectedSeamlessPromoObj) {
            selectedSeamlessPromoId = selectedSeamlessPromoObj.id;
            selectedSeamlessPromoCode = selectedSeamlessPromoObj.code;
        }
    } else if (selectedPromoId) {
        selectedSeamlessPromoObj = promoObj;

        if (selectedSeamlessPromoObj) {
            selectedSeamlessPromoId = selectedSeamlessPromoObj?.id;
            selectedSeamlessPromoCode = selectedSeamlessPromoObj?.code;
        }
    }

    return {
        selectedSeamlessPromoObj,
        selectedSeamlessPromoId,
        selectedSeamlessPromoCode,
    };
};

export const seamless_getSeamlessPromotion = async ({ languageKey, isSeamlessPromotionExist, platform }) => {
    let retries = 0;
    let response = null;
    let data = null;

    const fetchWithRetry = async () => {
        try {
            response = await getSeamlessPromotions(languageKey, 'DEPOSIT', isSeamlessPromotionExist, platform);
            if (response?.code === '10000') {
                data = response?.data;
            }
        } catch (err) {
            if (err?.data?.code === 'SW20020' && retries < 3) {
                retries++;
                await fetchWithRetry();
            } else {
                console.error(err);
            }
        }
    };

    await fetchWithRetry();

    return { seamlessPromotionsList: data };
};

export const seamless_getSeamlessTransferWallet = (seamlessTransferWallets) => {
    if (!seamlessTransferWallets || Object.keys(seamlessTransferWallets).length === 0) {
        return {
            seamlessTransferWalletsWithoutGroup: [],
            totalAmount: 0,
        };
    }

    const allWallets = Object.values(seamlessTransferWallets).flat();

    // Create a Set to track processed wallet combinations to prevent duplicates
    const processedWallets = new Set();

    const mergedWalletsMap = allWallets.reduce((accumulator, currentWallet) => {
        const key = currentWallet.provider;
        const currentBalance = parseFloat(currentWallet.balance) || 0;

        // Create a unique identifier for this wallet to prevent duplicate processing
        const walletIdentifier = `${key}-${currentBalance}-${currentWallet.category || ''}`;

        // Skip if we've already processed this exact wallet
        if (processedWallets.has(walletIdentifier)) {
            return accumulator;
        }
        processedWallets.add(walletIdentifier);

        if (!accumulator[key]) {
            accumulator[key] = { ...currentWallet, balance: currentBalance };
        } else {
            // Only add the balance if it's not already accounted for
            const existingBalance = parseFloat(accumulator[key].balance) || 0;
            if (existingBalance !== currentBalance) {
                accumulator[key].balance += currentBalance;
            }
        }

        return accumulator;
    }, {});

    const seamlessTransferWalletsWithoutGroup = Object.values(mergedWalletsMap).sort((a, b) => b.balance - a.balance);

    return {
        seamlessTransferWalletsWithoutGroup,
        totalAmount: seamlessTransferWalletsWithoutGroup.reduce((acc, curr) => acc + parseFloat(curr.balance), 0),
    };
};

export const seamless_checkPromotionValidate = async (seamlessPromoObj) => {
    if (!seamlessPromoObj) {
        return false;
    }

    try {
        const status = await window.SPL_Member.checkSeamlessPromotionValidate(seamlessPromoObj);
        return !!status;
    } catch (err) {
        console.error('Error checking promotion validation:', err);
        return false;
    }
};

export const seamless_processPromotionQueueData = ({ promotionQueueData, promoList, selectedPromotionId }) => {
    let tempSpecialPromoCode = '';
    let tempSelectedPromotionId = selectedPromotionId;
    let pendingPromotionQueue = false;
    let isPendingSpecialCode = false;
    let isCryptoPromoQueue = false;

    if (promotionQueueData) {
        pendingPromotionQueue = true;
        if (promoList?.length > 0) {
            for (let i = 0; i < promoList.length; i++) {
                if (promoList[i].id === promotionQueueData.seamlessPromotionId && promoList[i].code === promotionQueueData.promotionCode) {
                    tempSelectedPromotionId = promotionQueueData.seamlessPromotionId;
                    isPendingSpecialCode = false;
                    if (promotionQueueData.type === 'C') {
                        isCryptoPromoQueue = true;
                    }
                }
            }

            if (!tempSelectedPromotionId) {
                tempSpecialPromoCode = promotionQueueData.specialCode;
                isPendingSpecialCode = true;
                if (promotionQueueData.type === 'C') {
                    isCryptoPromoQueue = true;
                }
            }
        } else {
            tempSpecialPromoCode = promotionQueueData.specialCode;
            isPendingSpecialCode = true;
            if (promotionQueueData.type === 'C') {
                isCryptoPromoQueue = true;
            }
        }
    } else {
        pendingPromotionQueue = false;
    }

    return {
        pendingPromotionQueue,
        isPendingSpecialCode,
        isCryptoPromoQueue,
        specialPromoCode: tempSpecialPromoCode,
        selectedPromotionId: !isPendingSpecialCode ? promotionQueueData?.seamlessPromotionId || tempSelectedPromotionId : '',
    };
};

export const seamless_applyCryptoPromotion = async ({
    specialPromo,
    promoList,
    selectedSeamlessPromoObj,
    selectedPromotionId,
    selectedChain,
    language,
    compSettings,
    onPhoneVerificationRequired,
    onRiskRestriction,
    onError,
    onSuccess,
    dispatch,
}) => {
    const {
        selectedSeamlessPromoObj: finalSelectedSeamlessPromoObj,
        selectedSeamlessPromoId,
        selectedSeamlessPromoCode,
    } = seamless_massageSelectedSeamlessPromo({
        specialPromoObj: specialPromo,
        promoObj: selectedSeamlessPromoObj,
    });

    const seamlessPromoObj = finalSelectedSeamlessPromoObj;
    const seamlessPromoId = selectedSeamlessPromoId;
    const seamlessPromoCode = selectedSeamlessPromoCode;

    const params = {
        bank: selectedChain && selectedChain.code,
        methodCode: selectedChain && selectedChain.code,
        merchantCode: window.merchantCode,
        portalLanguage: language && language.countryLanguageKey,
        merchantBankId: selectedChain && selectedChain.id,
        amount: null,
        seamlessPromoId: seamlessPromoId,
        promoCode: seamlessPromoCode,
    };

    const needsPhoneVerification = compSettings && compSettings.isDisablePromoCode && seamlessPromoObj && seamlessPromoObj.isPhoneVerification;

    if (needsPhoneVerification) {
        try {
            const isReqVerification = await window.SPL_Member.getPhoneRequiredVerification();
            if (isReqVerification) {
                // Phone verification required - call callback with continue function
                if (onPhoneVerificationRequired) {
                    onPhoneVerificationRequired(async () => {
                        await proceedWithValidation();
                    });
                } else {
                    await proceedWithValidation();
                }
                return { requiresPhoneVerification: true };
            } else {
                await proceedWithValidation();
            }
        } catch (err) {
            console.error('Error checking phone verification:', err);
            if (onError) {
                onError(err);
            }
            return { success: false, error: err };
        }
    } else {
        await proceedSubmit();
    }

    async function proceedWithValidation() {
        const isValid = await seamless_checkPromotionValidate(seamlessPromoObj);
        if (!isValid) {
            if (onRiskRestriction) {
                onRiskRestriction();
            }
            return { success: false, riskRestriction: true };
        } else {
            await proceedSubmit();
        }
    }

    async function proceedSubmit() {
        try {
            const res = await window.SPL_Member.applySeamlessCryptoPromotion(params);
            if (res && res.status === 'S') {
                const promotionQueueData = res.data;

                const stateUpdates = seamless_processPromotionQueueData({
                    promotionQueueData,
                    promoList,
                    selectedPromotionId,
                });

                if (dispatch && promotionQueueData) {
                    dispatch(seamlessAction.isSeamlessPromotionExist(true));
                }

                if (onSuccess) {
                    onSuccess({
                        success: true,
                        stateUpdates,
                        promotionQueueData,
                        selectedPromotionId: stateUpdates.selectedPromotionId,
                    });
                }

                return {
                    success: true,
                    stateUpdates,
                    promotionQueueData,
                    selectedPromotionId: stateUpdates.selectedPromotionId,
                };
            } else {
                const errorMessage = res?.errorMsg || 'Error applying crypto promotion';
                if (onError) {
                    onError(errorMessage);
                }
                return {
                    success: false,
                    error: errorMessage,
                    stateUpdates: {
                        pendingPromotionQueue: false,
                    },
                };
            }
        } catch (err) {
            console.error('Error applying crypto promotion:', err);
            if (onError) {
                onError(err);
            }
            return {
                success: false,
                error: err,
                stateUpdates: {
                    pendingPromotionQueue: false,
                },
            };
        }
    }
};

export const seamless_getProviderList = async ({ user, portalSettingsReducer, seamless, dispatch }) => {
    const props = {
        user,
        portalSettingsReducer,
        seamless,
        dispatch,
    };

    try {
        const res = await window.SPL_Provider.getAllProviderWalletList(null, true, props);
        return res;
    } catch (err) {
        console.error('Error getting provider list:', err);
        return null;
    }
};
